import React, { useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { FaPhoneAlt, FaTimes } from "react-icons/fa";
import { FaVideo } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { video_modal } from "../../Pages/actions/video_audio_modal";
import socketModel from "../../models/socketModel";
import { useNavigate } from "react-router-dom";
import methodModel from "../../methods/methods";
const VideoCallRingModal = ({ isOpen, setIsOpen, roomId, CallingUserData = {}, onAcceptCustom = null }) => {
    const [RoomDetails, setRoomDetails] = useState({});
    const history = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const chats = useSelector((state) => state.chats?.data);

    const acceptedRef = React.useRef(false);
    const [isConnecting, setIsConnecting] = useState(false);
    const activeRoomIdRef = React.useRef("");

    if (roomId && String(roomId).trim() !== "" && String(roomId) !== "null" && String(roomId) !== "undefined") {
        activeRoomIdRef.current = String(roomId).trim();
    } else if (CallingUserData?.room_id && String(CallingUserData.room_id) !== "null") {
        activeRoomIdRef.current = String(CallingUserData.room_id).trim();
    }

    const getEffectiveRoomId = () => {
        let savedFromStorage = "";
        try {
            const raw = localStorage.getItem("BackToVedioCall");
            if (raw) savedFromStorage = JSON.parse(raw)?.room_id;
        } catch (e) {}

        const candidates = [
            roomId,
            activeRoomIdRef.current,
            CallingUserData?.room_id,
            CallingUserData?.roomId,
            CallingUserData?._id,
            CallingUserData?.id,
            CallingUserData?.channel,
            RoomDetails?.room_id,
            RoomDetails?._id,
            RoomDetails?.id,
            savedFromStorage,
            localStorage.getItem("lastChatRoomId")
        ];
        for (const candidate of candidates) {
            if (candidate && String(candidate).trim() !== "" && String(candidate) !== "null" && String(candidate) !== "undefined") {
                return String(candidate).trim();
            }
        }
        return "";
    };

    useEffect(() => {
        const targetId = getEffectiveRoomId();
        if (targetId) {
            activeRoomIdRef.current = targetId;
        }
        if (chats && targetId) {
            const found = chats?.find((_data) => String(_data?.room_id) === String(targetId) || String(_data?._id) === String(targetId) || String(_data?.id) === String(targetId)) || {};
            setRoomDetails((prev) => {
                const prevId = String(prev?.room_id || prev?._id || prev?.id || "");
                const foundId = String(found?.room_id || found?._id || found?.id || "");
                if (prevId === foundId) return prev;
                return found;
            });
        }
        if (isOpen) {
            acceptedRef.current = false;
            setIsConnecting(false);
        }
    }, [roomId, chats, isOpen, CallingUserData?.room_id, CallingUserData?._id]);

    const onClose = () => {
        localStorage.removeItem("BackToVedioCall");
        setIsConnecting(false);
        if (!acceptedRef.current) {
            const targetRoom = getEffectiveRoomId();
            const isGroupCall = Boolean(RoomDetails?.isGroupChat || RoomDetails?.groupType || RoomDetails?.group_type || RoomDetails?.type === 'group' || (Array.isArray(RoomDetails?.room_members) && RoomDetails.room_members.length > 2) || CallingUserData?.isGroupChat);
            if (targetRoom) {
                socketModel.emit('stop-video-call', {
                    room_id: targetRoom,
                    reason: "declined",
                    user_id: user?.id || user?._id,
                    isDecline: true,
                    isOwner: !isGroupCall
                });
            }
        }
        setIsOpen(false);
        dispatch(video_modal(false));
    };

    const onAccept = () => {
        if (isConnecting) return;
        const targetRoom = getEffectiveRoomId();
        if (!targetRoom) {
            console.error("Cannot accept video call: roomId is null or invalid", { roomId, CallingUserData, RoomDetails });
            return;
        }
        setIsConnecting(true);
        acceptedRef.current = true;
        socketModel.emit("accept-call", {
            room_id: targetRoom,
            call_type: "video"
        });
        let value = {
            room_id: targetRoom,
            isVedioCall: true,
        };
        localStorage.setItem("BackToVedioCall", JSON.stringify(value));
        if (onAcceptCustom) {
            onAcceptCustom(targetRoom);
        } else {
            history(`/chat?room_idd=${targetRoom}&videoCall=true`);
            setTimeout(() => {
                setIsOpen(false);
                dispatch(video_modal(false));
            }, 3000);
        }
    };

    return (
        <Transition appear show={isOpen} as={React.Fragment}>
            <Dialog as="div" className="relative z-[9999]" onClose={isConnecting ? () => { } : onClose}>
                {/* Backdrop */}
                <Transition.Child
                    as={React.Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-xl" />
                </Transition.Child>

                <div className="fixed inset-0 flex items-center justify-center p-4 z-[10000]">
                    {/* Modal Panel */}
                    <Transition.Child
                        as={React.Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Dialog.Panel className="w-full max-w-sm transform overflow-hidden rounded-3xl bg-slate-900/90 p-7 text-center shadow-[0_25px_60px_-15px_rgba(0,0,0,0.7)] backdrop-blur-2xl border border-white/10 text-white transition-all">
                            {/* Call Header badge */}
                            {isConnecting ? (
                                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/20 border border-emerald-500/30 text-emerald-300 text-xs font-semibold mb-5">
                                    <span className="w-2 h-2 rounded-full bg-emerald-400 animate-ping"></span>
                                    Connecting Video Call...
                                </div>
                            ) : (
                                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-300 text-xs font-semibold mb-5">
                                    <span className="w-2 h-2 rounded-full bg-indigo-400 animate-pulse"></span>
                                    Incoming Video Call
                                </div>
                            )}

                            {/* Avatar with sonar pulse animation */}
                            <div className="relative w-28 h-28 mx-auto mb-5 flex items-center justify-center">
                                <span className={`absolute inset-0 rounded-full animate-ping opacity-75 ${isConnecting ? 'bg-emerald-500/30' : 'bg-indigo-500/30'}`}></span>
                                <span className={`absolute -inset-3 rounded-full animate-pulse blur-sm ${isConnecting ? 'bg-emerald-500/20' : 'bg-purple-500/20'}`}></span>
                                <img
                                    src={methodModel.userImg(CallingUserData?.user_image)}
                                    className={`relative w-24 h-24 rounded-full object-cover border-4 shadow-xl ${isConnecting ? 'border-emerald-500 shadow-emerald-500/30' : 'border-indigo-500 shadow-indigo-500/30'}`}
                                    alt="Caller"
                                    onError={(e) => { e.target.src = 'https://via.placeholder.com/96?text=User'; }}
                                />
                            </div>

                            <h4 className="text-xl font-bold text-white mb-1 tracking-tight">
                                {CallingUserData?.name || (Boolean(RoomDetails?.isGroupChat || RoomDetails?.groupType || RoomDetails?.group_type || RoomDetails?.type === 'group' || (Array.isArray(RoomDetails?.room_members) && RoomDetails.room_members.length > 2) || CallingUserData?.isGroupChat) ? (RoomDetails?.room_name || CallingUserData?.room_name || "Group Call") : "Unknown User")}
                            </h4>
                            {isConnecting ? (
                                <p className="text-xs text-emerald-300 font-medium mb-8 flex items-center justify-center gap-2">
                                    <span className="w-3.5 h-3.5 border-2 border-emerald-400 border-t-transparent rounded-full animate-spin"></span>
                                    Joining room & connecting camera...
                                </p>
                            ) : (
                                <p className="text-xs text-indigo-300 font-medium mb-8 flex items-center justify-center gap-1.5">
                                    <FaVideo className="w-3 h-3 text-indigo-400 animate-pulse" />
                                    {Boolean(RoomDetails?.isGroupChat || RoomDetails?.groupType || RoomDetails?.group_type || RoomDetails?.type === 'group' || (Array.isArray(RoomDetails?.room_members) && RoomDetails.room_members.length > 2) || CallingUserData?.isGroupChat)
                                        ? `Video call in ${RoomDetails?.room_name || CallingUserData?.room_name || 'group'}...`
                                        : "Video call request..."}
                                </p>
                            )}

                            {/* Action Buttons */}
                            {isConnecting ? (
                                <div className="flex flex-col items-center justify-center gap-2 w-full py-2">
                                    <div className="flex items-center justify-center gap-2.5 px-6 py-3 rounded-2xl bg-emerald-500/20 border border-emerald-500/30 text-emerald-300 font-semibold text-sm shadow-lg shadow-emerald-500/20 w-full">
                                        <div className="w-4 h-4 border-2 border-emerald-400 border-t-transparent rounded-full animate-spin"></div>
                                        <span>Connecting call, please wait...</span>
                                    </div>
                                    <span className="text-[11px] text-white/60">Video will start shortly</span>
                                </div>
                            ) : (
                                <div className="flex items-center justify-center gap-4">
                                    <button
                                        className="flex-1 flex items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-rose-600 to-red-600 px-5 py-3.5 text-white font-semibold shadow-lg shadow-rose-600/30 hover:from-rose-500 hover:to-red-500 hover:scale-105 active:scale-95 transition-all duration-200 cursor-pointer"
                                        onClick={onClose}
                                    >
                                        <FaTimes className="w-4 h-4" />
                                        Decline
                                    </button>
                                    <button
                                        className="flex-1 flex items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-emerald-500 to-green-600 px-5 py-3.5 text-white font-semibold shadow-lg shadow-emerald-500/30 hover:from-emerald-400 hover:to-green-500 hover:scale-105 active:scale-95 transition-all duration-200 cursor-pointer"
                                        onClick={onAccept}
                                    >
                                        <FaVideo className="w-4 h-4" />
                                        Accept
                                    </button>
                                </div>
                            )}
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    );
};
export default VideoCallRingModal;